import { compose, withState, withHandlers, withProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { rest } from 'services'
import withType from 'components/common/hoc/withType'
import withScrollToAnchor from 'components/common/hoc/withScrollToAnchor'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import isEqual from 'lodash/isEqual'
import { BREADCRUMB_ID, SERVICE_CATEGORY_EMPTY_STATE } from './constants'
import { isServiceCategoryURL, getStoreBaseURL } from '../../helpers'
import { getStoreCityAndState } from './selectors'
import { getLocationPathname } from 'selectors/getPageLocation'
import StoreServices from './StoreServices'
import { getServiceCategory } from 'components/StoreDetailsPage/components/StoreServices/components/selectors.js'
import { isEmpty } from 'lodash'

const withLoadingState = withState('isLoading', 'setLoading', false)
const withServiceCategoryState = withState('serviceCategory', 'setServiceCategory', ({
  isServiceCategoryURL,
  serviceCategoryDetails = {}
}) => isServiceCategoryURL && !isEmpty(serviceCategoryDetails)
  ? { ...serviceCategoryDetails }
  : SERVICE_CATEGORY_EMPTY_STATE
)

const withScrollToProps = withProps({
  targetId: BREADCRUMB_ID,
  padding: 85
})

const mapStateToProps = state => {
  const pathname = getLocationPathname(state) || ''
  return {
    isServiceCategoryURL: isServiceCategoryURL(pathname),
    storeBaseURL: getStoreBaseURL(pathname),
    storeCityAndState: getStoreCityAndState(state),
    pathname,
    serviceCategoryDetails: getServiceCategory(state)
  }
}

const withUpdateServicesSection = withHandlers({
  updateServicesSection: ({ setLoading, setServiceCategory }) => (e, categoryId) => {
    if (categoryId) {
      setLoading(true)
      rest.api.getServiceCategoryDetails({ categoryId })
        .then(({
          categoryName,
          categoryLongDescription,
          serviceCategorySeo: serviceUrl
        }) => {
          setServiceCategory({
            categoryId,
            categoryName,
            categoryLongDescription,
            serviceUrl
          })
        })
        .finally(() => setLoading(false))
    } else {
      setServiceCategory({})
    }
  }
})

const withLifecyle = lifecycle({
  componentDidUpdate({ displayServiceCategory: prevDisplayServiceCategory, pathname: prevPathname }) {
    const {
      scrollToAnchorHandler,
      displayServiceCategory
    } = this.props
    displayServiceCategory !== prevDisplayServiceCategory && setTimeout(() => scrollToAnchorHandler())
  }
})

const withEnhancedProps = withProps(({ serviceCategory }) => ({
  displayServiceCategory: !isEqual(serviceCategory, SERVICE_CATEGORY_EMPTY_STATE)
}))

export default compose(
  withType({ type: 'BOTStoreServices' }),
  connect(mapStateToProps),
  withLoadingState,
  withServiceCategoryState,
  withRequestApptClick,
  withUpdateServicesSection,
  withScrollToProps,
  withScrollToAnchor,
  withEnhancedProps,
  withLifecyle
)(StoreServices)
